export function useIdleFlag(timeout = 2000) {
  const isIdle = ref(false);

  onMounted(() => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(
        () => { isIdle.value = true; },
        { timeout },
      );
    } else {
      setTimeout(() => {
        isIdle.value = true;
      }, timeout);
    }
  });

  return { isIdle };
}
